<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app  height
    dark class="drawer-flipped"
    floating 
    persistent
    mobile-breakpoint="991"
    width="270"
  >
    <v-img
      :src="image"
      height="100%"
    >
      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
        <v-list-item>
          <v-list-item-avatar
            color="white"
          >
            <v-img
              :src="logo"
              height="45"
              contain
            />
          </v-list-item-avatar>
          <v-list-item-title class="title">
            Gis Mundo Sano
          </v-list-item-title>
        </v-list-item>
        <v-text-field
              name="menu-search" solo autocomplete="menu-search"
              label="Buscar..." append-icon="mdi-magnify" v-model="search"
              id="searchMenu"
        ></v-text-field>
       
        <div v-for="(link, i) in links">
           <v-list-item v-if="link.submenu == null"
            :key="i"
            :to="link.to"
            :active-class="color"
            class="v-list-item"
          >
            <v-list-item-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title v-text="link.text"/>
          </v-list-item>

          <v-list-group  v-else
            no-action
          >
            <v-list-item  style="padding: 0px" slot="activator">
              <v-list-item-action>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-title >{{ link.text }}</v-list-item-title>
            </v-list-item>
             <v-list-item  
                v-for="(subitem, i) in link.submenu"
                :key="i" class="v-list-item" :to="subitem.to"
              >
                <v-list-item-title >{{ subitem.text }}</v-list-item-title>
                <v-list-item-action>
                  <v-icon v-text="subitem.icon"></v-icon>
                </v-list-item-action>
              </v-list-item>
          </v-list-group>
        </div>
        <v-divider></v-divider>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'

export default {
  data: () => ({
    logo: '/img/logo1.png',
    value: 0,
    search: '',
    menu: false,
    allLinks: [],
    basePath: 'http://gis.localdev.com.ar/api/menu',
    responsive: false
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get () {
        if(this.$store.state.app.drawer && this.$store.state.api.logged){
          return true;
        }else{
          return false;
        }
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    },
    links: function(){
      if(this.search != ''){  
        return this.allLinks.filter((item) => {
          let value = false;
          if(item.submenu != null){
            value = item.submenu.filter((subitem) => {
              return subitem.text.toLowerCase().includes(this.search.toLowerCase());
            })
          }
          if(!value){
            value = item.text.toLowerCase().includes(this.search.toLowerCase());
          }
          return value;
        });
      }else{
        return this.allLinks;
      }
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  filterList: function(){

  },
  watch: {
    '$store.state.api.logged': function (){
      if(this.$store.state.api.logged){
        this.inputValue = true;
        //this.getMenu();
      }else{
        this.inputValue = false;
      }
    },
    '$store.state.api.menu': function (){  
      this.allLinks = this.$store.state.api.menu
    },

  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    },
    getMenu(){
      axios.get(this.basePath + '/getMenu').then((res) => {
        this.allLinks = res.data;
      }).catch((error) => {
        setTimeout(() => (this.getMenu()), 3000)
      });
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }
    .v-list-item{
      margin: 0 !important;
    }
    .drawer-containt{
      overflow-x: auto;
    }
    .drawer-flipped{
      direction: rtl !important;
    }
  }
</style>